/**
 * Utility functions for building image URLs
 */
import { getMediaUrl } from './mediaUrl';

/**
 * Build full image URL from relative path
 * @param path - Relative image path or full URL
 * @returns Full image URL
 */
export const buildImageUrl = (path: string | null | undefined): string | null => {
  if (!path) return null;

  return getMediaUrl(path);
};

/**
 * Default avatar placeholder - a simple gradient avatar
 */
export const DEFAULT_AVATAR = '/default-avatar.svg';

/**
 * Build avatar URL with fallback
 * @param avatarUrl - Avatar URL from user object
 * @param fallbackToDefault - Whether to return default avatar if null (default: true)
 * @returns Avatar URL or default avatar URL
 */
export const buildAvatarUrl = (avatarUrl: string | null | undefined, fallbackToDefault: boolean = true): string | null => {
  if (!avatarUrl) {
    return fallbackToDefault ? DEFAULT_AVATAR : null;
  }
  return buildImageUrl(avatarUrl);
};
